"use client";

import { MdUpload } from "react-icons/md";
import { toast, ToastContainer } from "react-toastify";
import { useActionState, useEffect } from "react";
import { uploadCmdFile } from "@/action/upload_excel_file";

export function UploadCmdFile() {
  const [state, formAction, isPending] = useActionState(uploadCmdFile, {
    success: false,
    error: null,
  });
  useEffect(() => {
    const uploadFn = async () => {
      if (state.success) {
        toast.success("Fichier téléversé avec succée");
      } else {
        toast.error(state.error);
      }
    };

    uploadFn();
  }, [state]);
  return (
    <form action={formAction} className="flex flex-col items-start lg:items-center gap-4 w-[70%] lg:flex-row lg:w-auto">
      <ToastContainer />
      {/* <label htmlFor="file" className=" border border-dashed p-2 rounded-sm ">
        Clicker pour selectionner le fichier
      </label> */}
      <div className="relative w-[80%] lg:w-auto ">
        <input
          type="file"
          name="file"
          id="file"
          accept=".xlsx,.xls"
          placeholder="selectionne un fichier"
          // hidden
          className="border border-dashed w-full border-white p-2 outline-none rounded-md "
        />
        <div className="h-5 w-5 rounded-full bg-green-main flex justify-center items-center text-xs lg:text-sm absolute -right-1 -top-1">
          {" "}
          2
        </div>
      </div>
      {isPending ? (
        <div className="flex flex-col justify-center gap-2 w-[80%] lg:w-auto ">
          {/* <span>Entrain de chager</span> */}
          <span className="animate-spin rounded-full h-5 w-5 border-b-3 border-white" />
        </div>
      ) : (
        <button
          type="submit"
          disabled={isPending}
          className="p-2 relative w-[80%] lg:w-auto  flex justify-center items-center gap-4 transition-all duration-200 rounded-sm bg-white text-[#111]  cursor-pointer text-centerhover:bg-gray-300 "
        >
          {/* <p>Commande deja completee</p> */}
          <MdUpload className="text-2xl" />

          <div className="h-5 w-5 text-white rounded-full bg-green-main flex justify-center items-center text-xs lg:text-sm absolute -right-2 -top-1">
            {" "}
            3
          </div>
        </button>
      )}
    </form>
  );
}
